export enum UserLocationRole {
  user = 'user',
  manager = 'manager',
}
